var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.594 13.7119C28.594 16.8583 31.1484 19.4089 34.2994 19.4089C34.6464 19.4072 34.9925 19.3739 35.3334 19.3094V30.6041C35.3334 35.3558 32.5305 38.167 27.7718 38.167H17.4074C12.6363 38.167 9.83337 35.3558 9.83337 30.6041V20.2548C9.83337 15.5031 12.6363 12.667 17.4074 12.667H28.6937C28.6267 13.0112 28.5933 13.3612 28.594 13.7119ZM25.6292 28.1038L29.6778 22.8794V22.8546C30.0244 22.3888 29.9359 21.7321 29.4785 21.3743C29.257 21.2034 28.9757 21.1294 28.6986 21.1692C28.4216 21.2091 28.1726 21.3594 28.0085 21.5858L24.5952 25.9767L20.7086 22.9167C20.4867 22.7439 20.2044 22.6675 19.9254 22.705C19.6465 22.7424 19.3944 22.8905 19.2261 23.1158L15.0405 28.5143C14.8934 28.6977 14.8142 28.9262 14.8163 29.1611C14.792 29.636 15.0919 30.0674 15.5459 30.2107C16 30.354 16.4937 30.1732 16.7472 29.7706L20.2476 25.2428L24.1343 28.2904C24.3554 28.4686 24.6395 28.5494 24.9214 28.5142C25.2034 28.479 25.4588 28.3309 25.6292 28.1038Z",
    fill: "#1279DA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 34.625,
    cy: 13.3747,
    r: 3.54167,
    fill: "#1279DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiicon2);
export default __webpack_public_path__ + "static/media/kpiicon2.db67d97d698dfddd696615d705df6571.svg";
export { ForwardRef as ReactComponent };